import { useEffect, useState } from "react";
import {
  SpendOrganization,
  useSpendOrganizationQuery,
} from "../graphql/generated";
import { SnapSelectMenuOption } from "@snap-mobile/snap-ui/dist/types/utils";
import { ArchiveName } from "../helpers/archive-name";

export type OrganizationContextType = {
  organization: SpendOrganization | undefined;
  is: (id: string) => boolean;
  getGroupMenuItems: (groupId?: string) => SnapSelectMenuOption[];
};

export default function useOrganization() {
  const [organization, setOrganization] = useState<SpendOrganization>();

  const { loading: loadingOrganization, data: organizationData } =
    useSpendOrganizationQuery();

  useEffect(() => {
    if (!loadingOrganization && organizationData?.spendOrganization) {
      setOrganization(organizationData.spendOrganization as SpendOrganization);
    }
  }, [loadingOrganization, organizationData]);

  const is = (id: string) => {
    return id.startsWith("spdorg_");
  };

  const getGroupMenuItems = (groupId?: string): SnapSelectMenuOption[] => {
    let groups = [...(organization?.groups ?? [])];
    if (groupId) {
      groups = groups?.filter((g) => g?.id === groupId);
    }

    if (groups?.length) {
      groups.sort((a, b) =>
        a!.name?.toLowerCase()! < b!.name?.toLowerCase()!
          ? -1
          : a!.name?.toLowerCase()! > b!.name?.toLowerCase()!
          ? 1
          : 0
      );
    }

    return (
      groups?.map((group) => {
        return {
          name: ArchiveName(group?.name ?? "", group?.isArchived ?? false),
          selected: false,
          value: group?.id!,
        };
      }) ?? []
    );
  };

  return {
    organization,
    is,
    getGroupMenuItems,
  };
}
